import React from "react";
import { CircularProgress, IconButton, Tooltip } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import { FileItemContainer, FileItemIcon, FilePath } from "../UploadForm/UploadForm.elements";

export const SourceFileRow = ({ file, isDownloading, onDownload }) => {
  const disabled = file?.legacy || !file?.id;
  const label = disabled ? "Legacy file – download unavailable" : "Download source file";

  return (
      <FileItemContainer data-testid="source-file-row">
        <FileItemIcon />
        <FilePath>{file.displayName || file.originalName}</FilePath>
        <Tooltip title={label} placement="top">
          <span>
            <IconButton
                size="small"
                onClick={() => !disabled && onDownload?.(file)}
                disabled={disabled || isDownloading}
                data-testid="download-button"
            >
              {isDownloading ? <CircularProgress size={18} /> : <DownloadIcon fontSize="small" />}
            </IconButton>
          </span>
        </Tooltip>
      </FileItemContainer>
  );
};

export default SourceFileRow;
